<template>
  <v-content fill-height class="stock page">
    <v-container class="mt-2 text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h1>IDX Stock Financial Report</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout row wrap class="text-xs-justify">
        <v-flex xs12 sm12 md6 class="px-2">
          <p>This data will be usefull if you investor with type Value Investor. Analysis based on financial report per quartal. So, we compare data from the quartal in this year with the same quartal one year ago.</p>
          <p>Decision to buy or sell is your responsible. We are not responsible in what happens with your assets in the future. We just provide result of analysis of financial report stock market per quartal in IDX.</p>
          <p>Check details to look all information per stock.</p>
        </v-flex>
        <!-- still error to searching, will be improved in the future -->
        <!-- <v-flex xs12 sm12 md3 class="px-2">
          <v-text-field
            hide-details
            prepend-icon="search"
            single-line
            @canplaythrough="searchStock"
            @input="searchStock"
          ></v-text-field>
        </v-flex> -->
        <v-flex xs12 sm12 md6 class="px-2">
          <v-select :items="items" label="Filter" @input="filterStock"></v-select>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <Loading v-if="loading" />
      <v-card v-if="loading==false">
        <v-card-title>
          IDX Stock Financial Report in Quartal : {{stocks[0].quartal}}. The last scan at : {{ dateNow }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search in table"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="stocks" :search="search" :rows-per-page-items="[30,50]">
          <template v-slot:items="props">
            <td class="text-xs-right">{{ props.index + 1 }}</td>
            <td class="text-xs-right">{{ props.item.stock }}</td>
            <td class="text-xs-right">{{ props.item.assets }}</td>
            <td class="text-xs-right">{{ props.item.liabilities }}</td>
            <td class="text-xs-right">{{ props.item.equity }}</td>
            <td class="text-xs-right">{{ props.item.earnings }}</td>
            <td class="text-xs-right">{{ props.item.net_income }}</td>
            <td class="text-xs-right">{{ props.item.eps }}</td>
            <td class="text-xs-right">{{ props.item.report_three.total }}</td>
            <td class="text-xs-right">
              <StockDetails v-bind:stock="props" />
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
    <v-container class="mt-2 text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-pagination v-model="page.first" :length="page.length" :total-visible="7" @input="next"></v-pagination>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Loading from "../components/Loading";
import StockDetails from "./StockDetails";
import axios from "axios";

export default {
  components: { Loading, StockDetails },
  data() {
    return {
      // urlOrigin:"https://stock-report-provider.herokuapp.com/api/v1",
      // urlOrigin: "http://localhost:9090",
      urlOrigin: "https://goinvest.herokuapp.com",
      loading: true,
      search: "",
      quartal: 0,
      filter: "All",
      dateNow: new Date(),
      page: {
        first: 1,
        length: 15
      },
      items: [
        "All",
        "Top 100",
        "Agriculture",
        "Mining",
        "Basic Industry And Chemicals	",
        "Miscellaneous Industry",
        "Consumer Goods Industry",
        "Property, Real Estate And Building Construction	",
        "Infrastructure, Utilities And Transportation",
        "Finance",
        "Trade, Services & Investment"
      ],
      headers: [
        { text: "No", value: "no", sortable: false, width: "1%" },
        {
          text: "Stock",
          align: "left",
          value: "stock",
          width: "1%"
        },
        { text: "Assets (%)", value: "assets" },
        { text: "Liabilities (%)", value: "liabilities" },
        { text: "Equity (%)", value: "equity" },
        { text: "Earnings (%)", value: "earnings" },
        { text: "Net Income (%)", value: "net_income" },
        { text: "EPS (%)", value: "eps" },
        { text: "Point", value: "report_three.total", width: "1%" },
        { text: "Details", value: "details", sortable: false, width: "1%" }
      ],
      stocks: []
    };
  },
  mounted() {
    if(new Date().getDate() > 15){
        this.urlOrigin= "https://goinvest-server2.herokuapp.com"
    }
    axios
      .get(this.urlOrigin + "/stocks")
      .then(res => {
        this.stocks = res.data.data;
        this.page.length = Math.ceil(
          res.data.pagination.total / res.data.pagination.per_page
        );
        const lastCreate = new Date(this.stocks[0].created_at);
        this.dateNow = `${lastCreate.getFullYear()}-${lastCreate.getMonth()+1}-${lastCreate.getDate()}`;
        return (this.loading = false);
      })
      .catch(err => console.log(err));
  },
  methods: {
    filterStock(event) {
      this.loading = true;
      if (event == "All") {
        this.filter = "All";
        axios
          .get(this.urlOrigin + "/stocks")
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      } else if (event == "Top 100") {
        this.filter = "Top 100";
        axios
          .get(this.urlOrigin + "/stocks?filter=top100")
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      } else {
        this.filter = event;
        axios
          .get(this.urlOrigin + "/stocks?sector=" + event)
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      }
    },
    next(event) {
      this.loading = true;
      if (this.filter == "All") {
        axios
          .get(this.urlOrigin + "/stocks?page=" + event)
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      } else if (this.filter == "Top 100") {
        axios
          .get(this.urlOrigin + "/stocks?filter=top100&page=" + event)
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      } else {
        axios
          .get(
            this.urlOrigin + "/stocks?sector=" + this.filter + "&page=" + event
          )
          .then(res => {
            this.stocks = res.data.data;
            this.page.length = Math.ceil(
              res.data.pagination.total / res.data.pagination.per_page
            );
            return (this.loading = false);
          })
          .catch(err => console.log(err));
      }
    },
    // searchStock(event) {
    //   this.loading = true;
    //   if (event == "") {
    //     axios
    //       .get(this.urlOrigin + "/stocks")
    //       .then(res => {
    //         this.stocks = res.data.data;
    //         this.page.length = Math.ceil(
    //           res.data.pagination.total / res.data.pagination.per_page
    //         );
    //         return (this.loading = false);
    //       })
    //       .catch(err => console.log(err));
    //   } else {
    //     axios
    //       .get(this.urlOrigin + "/stocks?search=" + event)
    //       .then(res => {
    //         this.stocks = res.data.data;
    //         this.page.length = Math.ceil(
    //           res.data.pagination.total / res.data.pagination.per_page
    //         );
    //         return (this.loading = false);
    //       })
    //       .catch(err => console.log(err));
    //   }
    // }
  }
};
</script>

<style>
</style>
